import { useSyncExternalStore } from 'react';
import { systemsQuerySession } from 'utils/systems-query-session';

export default function useHasSystemsQueryRun(): boolean {
  return useSyncExternalStore(
    systemsQuerySession.subscribe,
    systemsQuerySession.hasRun
  );
}
